import { StyleSheet } from "react-native";

import { radii, spacing, type ThemeColors } from "~/styles/theme";

export const makeStylesheet = (colors: ThemeColors) =>
  StyleSheet.create({
    metricsGrid: {
      flexDirection: "row",
      flexWrap: "wrap",
      gap: spacing.m,
    },
    metric: {
      minWidth: 150,
      flex: 1,
    },
    reportCard: { flexGrow: 1, flexShrink: 1, flexBasis: 300, minWidth: 260 },
    reportGrid: {
      flexDirection: "row",
      flexWrap: "wrap",
      gap: spacing.m,
    },
    filterGrid: {
      flexDirection: "row",
      flexWrap: "wrap",
      gap: spacing.m,
    },
    filterField: {
      minWidth: 220,
      flex: 1,
      gap: spacing.xs,
    },
    wideFilter: {
      flexBasis: "100%",
    },
    actions: {
      flexDirection: "row",
      flexWrap: "wrap",
      gap: spacing.s,
    },
    savedViewForm: {
      flexDirection: "row",
      flexWrap: "wrap",
      alignItems: "flex-end",
      gap: spacing.s,
    },
    savedViewName: {
      minWidth: 260,
      flex: 1,
      gap: spacing.xs,
    },
    savedViewRow: {
      flexDirection: "row",
      flexWrap: "wrap",
      alignItems: "center",
      justifyContent: "space-between",
      gap: spacing.m,
      padding: spacing.m,
      borderRadius: radii.m,
      backgroundColor: colors.surfaceSunken,
    },
    savedViewMain: {
      flex: 1,
      minWidth: 220,
      gap: spacing.xs,
    },
    savedViewActions: {
      flexDirection: "row",
      flexWrap: "wrap",
      gap: spacing.s,
    },
    snapshotSummary: {
      flexDirection: "row",
      flexWrap: "wrap",
      gap: spacing.s,
    },
    snapshotMetric: {
      minWidth: 160,
      flexGrow: 1,
      gap: spacing.xs,
      padding: spacing.s,
      borderWidth: 1,
      borderColor: colors.hairline,
      borderRadius: radii.s,
      backgroundColor: colors.surfaceSunken,
    },
    snapshotForm: {
      flexDirection: "row",
      flexWrap: "wrap",
      alignItems: "flex-end",
      gap: spacing.s,
    },
    snapshotLabelField: { minWidth: 220, flex: 1, gap: spacing.xs },
    snapshotNoteField: { minWidth: 260, flex: 2, gap: spacing.xs },
    exportGrid: {
      flexDirection: "row",
      flexWrap: "wrap",
      gap: spacing.s,
    },
    reportRow: {
      minHeight: 38,
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      gap: spacing.m,
      paddingVertical: spacing.s,
      borderBottomWidth: 1,
      borderBottomColor: colors.hairline,
    },
    reportMain: {
      flex: 1,
      minWidth: 160,
      gap: spacing.xs,
    },
    timeMix: {
      flexDirection: "row",
      flexWrap: "wrap",
      gap: spacing.m,
    },
    timeTile: {
      minWidth: 160,
      flex: 1,
      gap: spacing.xs,
      padding: spacing.m,
      borderWidth: 1,
      borderColor: colors.hairline,
      borderRadius: radii.m,
      backgroundColor: colors.surfaceSunken,
    },
  });
